import React from 'react';
import moment from 'moment';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export type FooterComponent = React.FC<{ lastUpdated?: string }>;

const Footer: FooterComponent = ({ lastUpdated }) => {
    const { t } = useTranslation('footer');
    const currentYear = moment().format('YYYY');
    return (
        <div className={classes['footer']}>
            {t('text')} {currentYear}
            {lastUpdated && <><br />Last updated: {lastUpdated}</>}
        </div>
    );
};

export default Footer;
